import React from 'react';

const JobPosting = () => {
  return (
    <div className="pt-16 px-4 min-h-screen bg-background text-light">
      <div className="max-w-4xl mx-auto py-12">
        <h1 className="text-4xl font-bold text-primary mb-8">Program Assistant - Education</h1>
        
        {/* Job Introduction */}
        <section className="mb-12">
          <div className="bg-light-gray p-6 rounded-lg shadow-lg">
            <p className="text-xl text-secondary mb-6">
              Join us for a dynamic summer role that will put your education and dance skills center stage! Rueda de la Vida Dance Society is seeking an enthusiastic and detail-oriented Program Assistant to help bring our vibrant educational programs and camps to life.
            </p>
          </div>
        </section>

        {/* Job Responsibilities */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-primary mb-6">Responsibilities</h2>
          
          {/* Program Support Section */}
          <div className="bg-light-gray p-6 rounded-lg shadow-lg mb-6">
            <h3 className="text-xl font-bold text-primary mb-4">A. Program Support</h3>
            <ul className="list-disc list-inside mb-4 text-secondary">
              <li>Assist in setting up, running, and cleaning up activities focused on movement and math concepts</li>
              <li>Actively participate in facilitating group games, exercises, and learning activities</li>
              <li>Adapt activities to suit different age groups and ability levels</li>
            </ul>
          </div>
          
          {/* Child Supervision Section */}
          <div className="bg-light-gray p-6 rounded-lg shadow-lg mb-6">
            <h3 className="text-xl font-bold text-primary mb-4">B. Child Supervision</h3>
            <ul className="list-disc list-inside mb-4 text-secondary">
              <li>Ensure the safety and well-being of all campers at all times</li>
              <li>Foster an inclusive and supportive environment where all participants feel encouraged and valued</li>
              <li>Monitor campers' participation and provide support when needed</li>
            </ul>
          </div>
          
          {/* Collaboration Section */}
          <div className="bg-light-gray p-6 rounded-lg shadow-lg mb-6">
            <h3 className="text-xl font-bold text-primary mb-4">C. Collaboration</h3>
            <ul className="list-disc list-inside mb-4 text-secondary">
              <li>Work closely with camp facilitators and staff to ensure smooth program delivery</li>
              <li>Communicate effectively with team members about camper needs or challenges</li>
              <li>Help maintain equipment and supplies for camp activities</li>
            </ul>
          </div>
          
          {/* Administrative Duties Section */}
          <div className="bg-light-gray p-6 rounded-lg shadow-lg mb-6">
            <h3 className="text-xl font-bold text-primary mb-4">D. Administrative Duties</h3>
            <ul className="list-disc list-inside mb-4 text-secondary">
              <li>Assist with camper check-in/out procedures and attendance tracking</li>
              <li>Report incidents, injuries, or concerns promptly to the Camp Coordinator</li>
            </ul>
          </div>
          
          {/* Other Duties Section */}
          <div className="bg-light-gray p-6 rounded-lg shadow-lg">
            <h3 className="text-xl font-bold text-primary mb-4">E. Other Duties as Assigned</h3>
            <ul className="list-disc list-inside mb-4 text-secondary">
              <li>Provide additional support as needed, such as preparing materials or assisting with special events</li>
            </ul>
          </div>
        </section>

        {/* Apply Section */}
        <section className="mb-12">
          <div className="bg-light-gray p-6 rounded-lg shadow-lg">
            <h3 className="text-xl font-bold text-primary mb-4">How to Apply</h3>
            <p className="text-secondary mb-6">
              If you're looking for a rewarding summer position that combines education with creative movement, we'd love to hear from you!
            </p>
            <p className="text-secondary text-center">
              To apply, please email your resume and cover letter to <a href="mailto:info@ruedadance.org" className="text-primary hover:underline">info@ruedadance.org</a> with the subject "Program Assistant - Education Application".
            </p>
          </div>
        </section>

        {/* Additional Information */}
        <section>
          <div className="bg-light-gray p-6 rounded-lg shadow-lg">
            <h3 className="text-xl font-bold text-primary mb-4">Job Information</h3>
            <ul className="space-y-2 text-secondary">
              <li>• Summer seasonal position (July - August)</li>
              <li>• Location: Vancouver, BC</li>
              <li>• Experience working with children preferred</li>
              <li>• Background in dance, movement, or education a plus</li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  );
};

export default JobPosting;